import type { MapSearchInput } from '@/shared/utils/queryUtils'

export const creditMemoTableFields: MapSearchInput['path'] = {
    name: ['reference', 'canceledInvoiceId'],
    number: ['reference', 'canceledInvoiceId']
}
